import { Component, EventEmitter, Output } from '@angular/core';
import { OrganisationPermissionType } from '@assetaccountant/api/models/organisation-permission-type';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-organisation-confirm-modal',
  templateUrl: './create-organisation-confirm-modal.component.html',
  styleUrls: ['./create-organisation-confirm-modal.component.scss'],
  standalone: false,
})
export class CreateOrganisationConfirmModalComponent {
  @Output() createOrganisation = new EventEmitter();
  @Output() createRegister = new EventEmitter();

  readonly OrganisationPermissionType = OrganisationPermissionType;

  constructor(public modal: NgbActiveModal) {}

  onCreateOrganisation() {
    this.createOrganisation.emit();
    this.modal.close();
  }

  onCreateRegister() {
    this.createRegister.emit();
    this.modal.close();
  }
}
